// @ts-nocheck
import { useTranslation } from 'react-i18next'
import { useQuery } from '@apollo/client/react'
import useWindowScrollPosition from 'helpers/useWindowScrollPosition'

import { Container } from 'js/components/Grid'
import PageHeader from 'js/components/PageHeader/PageHeader'
import Section from 'js/components/Section/Section'
import { useSiteStore } from 'js/lib/stores'
import FeedView from 'js/page/Widget/components/Feed/FeedView'

import { EVENTS_LIST_WRAPPER } from './EventsPage.queries'
import type { EventsListWrapperQuery } from './EventsPage.queries.generated'

type Props = {
    data: EventsListWrapperQuery
}

const EventsInnerPage = ({ data }: Props) => {
    const { viewer, site } = data
    const eventTiles = useSiteStore(({ site }) => site.eventTiles)

    const { t } = useTranslation()

    const settings = {
        showTagFilter: site?.pageTagFilters.showAllTagCategories,
        showTagCategories: site?.pageTagFilters.showTagCategories,
        typeFilter: ['event'],
        showEventFilter: true,
        itemView: eventTiles ? 'tile' : 'list',
        itemCount: eventTiles ? 3 : 10,
    }

    useWindowScrollPosition('events')

    return (
        <>
            <PageHeader
                title={t('entity-event.name', { count: 2 })}
                canCreate={viewer?.canWriteToContainer}
                createLink="/events/add"
                createLabel={t('entity-event.create')}
            />
            <Section>
                <Container size={eventTiles ? 'large' : 'tiny'}>
                    <FeedView guid="events" settings={settings} />
                </Container>
            </Section>
        </>
    )
}

// First load data, otherwise useWindowScrollPosition and FeedView won't work properly
export const EventsPage = () => {
    const { data, loading } = useQuery(EVENTS_LIST_WRAPPER)

    // FIXME: we should show Skeleton or at least we are retrieving the information
    if (loading) {
        return null
    }

    return <EventsInnerPage data={data} />
}
